import { render, staticRenderFns } from "./highchart_wrapper.vue?vue&type=template&id=1063fe2a&"
import script from "./highchart_wrapper.vue?vue&type=script&lang=js&"
export * from "./highchart_wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports